/// <amd-module name="Agile/Common/Routes/SprintsRoutingHelpers" />
import { RouteContributions, RouteParameters, SprintPivots } from "Constants/RoutingConstants";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssLocationService } from "VSS/Platform/Location";

/**
 * Get a URL to a sprint content view
 * @param pageContext The VSS Page context
 * @param projectName The current project name
 * @param teamName The team name of the sprint
 * @param iterationPath The iteration path to navigate to
 * @param pivot Optional, a pivot to navigate to
 */
export function getSprintsContentRoute(
    pageContext: IVssPageContext,
    projectName: string,
    teamName: string,
    iterationPath: string,
    pivot?: string
): string {
    const locationService = pageContext.getService<IVssLocationService>("IVssLocationService");
    const routeValues: { [key: string]: string } = {
        [RouteParameters.Project]: projectName,
        [RouteParameters.TeamName]: teamName,
        [RouteParameters.Iteration]: iterationPath
    };

    if (pivot) {
        routeValues[RouteParameters.Pivot] = pivot;
    } else {
        routeValues[RouteParameters.Pivot] = SprintPivots.Taskboard;
    }
    return locationService.routeUrl(RouteContributions.SprintsContentRoute, routeValues);
}
